<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'gestaocreche'|translate}}</h1>

            <a class="btn btn-gray-fill" (click)="actionExcel()">
                <svg-icon class="right" src="assets/svg/downloads.svg"></svg-icon>{{'daycare.exportarplanilha'|translate}}
            </a>
            <a routerLink="/daycare/create" class="btn btn-secondary text-white" *ngIf="canWrite">
                <svg-icon class="mr-1" src="assets/svg/plus-circle.svg"></svg-icon>{{'daycare.novacrianca'|translate}}
            </a>
        </div>

        <div class="page-filter">
            <div class="input-material">
                <input id="keyword" [(ngModel)]="filter.keyword" (keyup.enter)="actionSearch()"
                       class="form-control" type="text" required/>
                <label for="keyword">
                    <svg-icon [svgClass]="'input-search'" src="assets/svg/search.svg"></svg-icon>
                    <span>{{'busca'|translate}}</span>
                </label>
            </div>

            <div class="input-material" *ngIf="showUnitySelector">
                <select id="unity" [(ngModel)]="filter.unityId" class="form-control">
                    <option [ngValue]="null">{{'todasunidades'|translate}}</option>
                    <option *ngFor="let u of unities" [ngValue]="u.id">{{u.name}}</option>
                </select>
                <label for="unity" class="mb-0 mr-3">{{'unidade'|translate}}</label>
            </div>

            <a (click)="actionSearch()" class="btn btn-primary btn-lg text-white offset-xl-3">
                {{'settings.dosearch'|translate}}
            </a>
            <a href="javascript:void(0)" (click)="clearFilter()"
               class="btn btn-secondary btn-lg text-white" type="button">
                <span>{{'limpar'|translate}}</span>
            </a>
        </div>

        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                <tr>
                    <th scope="col">{{'crianca'|translate}}</th>
                    <th scope="col">{{'colaborador'|translate}}</th>
                    <th scope="col">{{'re'|translate}}</th>
                    <th scope="col">{{'pessoasautorizadas'|translate}}</th>
                    <th class="w-10" scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="isNullOrUndefined(page.results) || page.results.length === 0">
                    <td colspan="5">
                        <p class="text-center my-5">{{'nenhumacriancacadastrada'|translate}}</p>
                    </td>
                </tr>
                <tr *ngFor="let l of page.results |
                paginate: {itemsPerPage: page.PageSize,
                currentPage: page.currentPage,
                totalItems: page.totalCount}">
                    <td>{{l.name}}</td>
                    <td>{{l.employee?.name}}</td>
                    <td>{{l.employee?.re}}</td>
                    <td>
                        <p class="text-center my-0" *ngIf="isNullOrUndefined(l.guardians) || l.guardians.length === 0">-</p>
                        <ul class="guardian-list" *ngIf="!isNullOrUndefined(l.guardians) && l.guardians.length > 0">
                            <li *ngFor="let g of l.guardians">
                                <span class="badge badge-primary mr-1" *ngIf="isParent(g)">{{'paimae'|translate}}</span>
                                <span>{{guardianLabel(g)}}</span>
                            </li>
                        </ul>
                    </td>
                    <td class="text-center">
                        <div class="table_action">
                            <svg-icon [routerLink]="'/daycare/detail/'+ l.id" src="assets/svg/eye.svg"></svg-icon>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="text-right">
            <pagination-controls
                    [previousLabel]="labels.previousLabel"
                    [nextLabel]="labels.nextLabel"
                    [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                    [screenReaderPageLabel]="labels.screenReaderPageLabel"
                    [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
                    (pageChange)="pageChanged($event)"></pagination-controls>
        </div>
    </div>
</div>
